// automatically generate getters and mutations for all store properties. Usage:
//
// import { bootstrap } from '~/utilities/vuex'
//
// export default bootstrap({
//   namespaced: true,
//   state: {
//     name: '',
//     email: ''
//   }
// })
// source: https://github.com/vuejs/vuex/issues/1037#issuecomment-341198590
export function bootstrap(module) {
    if (module.getters === undefined) {
        module.getters = {};
    }

    if (module.mutations === undefined) {
        module.mutations = {};
    }

    Object.keys(module.state).forEach(key => {
        if (module.getters[key] === undefined) {
            module.getters[key] = state => state[key];
        }
        if (module.mutations[key] === undefined) {
            module.mutations[key] = (state, value) => {
                state[key] = value;
            };
        }
    });

    return module;
}

// return index of element with attribute set to value
export function findWithAttr(array, attr, value) {
    for (let i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
            return i;
        }
    }
    return -1;
}
